"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const b_1 = __importDefault(require("b_"));
const pythia_libs_1 = require("@yandex-int/pythia-libs");
// import {VideoAttachment} from '../types';
const attachment_video_styles_1 = __importDefault(require("./attachment-video.styles"));
const b = b_1.default.with('attachment-video');
// type VideoAttachmentProps = Pick<VideoAttachment, 'service' | 'id' | 'extraParams'>;
const IFrameComponent = (props, ref) => {
    const { service, id, extraParams } = props;
    return ((0, jsx_runtime_1.jsx)("iframe", { ref: ref, allowFullScreen: true, src: (0, pythia_libs_1.genVideoLink)({ service, id, extraParams }), frameBorder: '0', scrolling: 'no', allow: 'autoplay; fullscreen; encrypted-media' }));
};
const IFrameComponentWithRef = (0, react_2.memo)((0, react_2.forwardRef)(IFrameComponent));
const VideoAttachmentComponent = (props, ref) => {
    const { children } = props, rest = __rest(props, ["children"]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b() }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: attachment_video_styles_1.default }), (0, jsx_runtime_1.jsx)(IFrameComponentWithRef, Object.assign({}, rest, { ref: ref })), children] })));
};
exports.default = (0, react_2.forwardRef)(VideoAttachmentComponent);
